<template lang="html">
  <v-container fluid>
    <!-- <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline mb-3">
          <span class="font-weight-bold d-flex align-center">
            <v-icon class="mr-3 black--text" @click="goBack()">
              mdi-arrow-left
            </v-icon>
            Menu
          </span>
        </h2>
      </v-col>
    </v-row> -->
    <template v-if="serveStatus === 'live'">
      <beach-club-live :url_id="geturlDomain" :outlet_id="''" />
    </template>
    <template v-else>
      <beach-club :url_id="geturlDomain" :outlet_id="''" />
    </template>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      serveStatus: process.env.VUE_APP_SERVE
    }
  },
  computed: {
    geturlDomain() {
      return this.$store.getters.urlDomain
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'reservation' }).catch(() => {})
    }
  }
}
</script>
<style>
/* @import url('https://cdn.jsdelivr.net/npm/vuetify@2.1.7/dist/vuetify.min.css'); */
/* @import 'https://cdnjs.cloudflare.com/ajax/libs/vuetify/2.0.11/vuetify.css';
@import 'https://cdnjs.cloudflare.com/ajax/libs/vuetify/2.0.11/vuetify.css.map'; */

/* payment css */

.v-responsive__content {
  margin-left: unset !important;;
}

/* cc */
.card-material {
  margin-top: 50px;
  padding: 16px;
  padding-top: 0px;
}

.v-card--material__heading {
  position: relative;
  -webkit-transition: .3s ease;
  transition: .3s ease;
  z-index: 1;
  width: 100%;
}

.v-card .v-card--material__heading {
  top: -40px;
}

.v-sheet {
  border-radius: 4px;
}

.v-card--material__heading .v-image {
  border-radius: 15px;
  -webkit-box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;
}

.v-card .v-card__text {
  padding-top: 0px;
}

.card-item__wrapper {
  display: flex;
  flex: 1 1 auto;
  padding: 25px 15px;
  height: 100%;
}

.card-item__chip {
  width: auto;
  height: 35px;
}

.card-item__type {
  max-width: 70px;
  max-height: 35px;
  height: auto;
  position: relative;
  overflow: hidden;
}

.card-item__type img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-fade-up-enter-active {
  transition: all 0.25s ease-in-out;
  transition-delay: 0.1s;
  position: relative;
}

.slide-fade-up-leave-active {
  transition: all 0.25s ease-in-out;
  position: absolute;
}

.slide-fade-up-enter {
  opacity: 0;
  transform: translateY(15px);
  pointer-events: none;
}

.slide-fade-up-leave-to {
  opacity: 0;
  transform: translateY(-15px);
  pointer-events: none;
}

.card-item__number {
  padding: 10px 15px;
  cursor: pointer;
}

.card-item__numberItem {
  line-height: 1;
  font-weight: 500;
  font-size: 18px;
  width: 12px;
  display: inline-block;
}

.card-flip {
  transition: transform 0.6s;
  transform-style: preserve-3d;
}

.isFlip {
  transform: rotateY(180deg);
}

.card-flip.isFlip .card-item__wrapper.front {
  display: none;
}

.card-item__wrapper.back {
  display: none;
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 15px;
  padding-bottom: 15px;
}

.card-item__wrapper.back .card-item__type {
  max-height: 25px;
}

.card-flip.isFlip .card-item__wrapper.back {
  display: flex;
  transform: rotateY(180deg);
}

.__expiredText {
  opacity: 0.7;
}

.__expiredDate,
.__expiredText {
  font-size: 10px;
}

.backBlack {
  height: 35px;
  width: 100%;
  background-color: #000;
}

.card__secret {
  height: 30px;
  background: #fff;
  width: 100%;
  padding-right: 10px;
  color: #1a3b5d;
  font-size: 18px;
  border-radius: 4px;
  -webkit-box-shadow: 0px 10px 20px -7px rgba(32, 56, 117, 0.35);
  box-shadow: 0px 10px 20px -7px rgba(32, 56, 117, 0.35);
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.card__secret span {
  font-size: 12px;
}

.body-back {
  padding: 0 15px;
}

.card-cvv {
  font-size: 12px;
  display: flex;
  justify-content: flex-end;
  padding: 2px 10px;
}
</style>
